import { DataTable, EmptyState, PageHeader, Pagination, Select } from "@cafe/ui";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router";
import { api, dt } from "../lib/api";
import { AUDIT_GROUPS, auditLabel, describe } from "../lib/labels";

type Row = { id: string; action: string; companyId: string | null; userName: string | null; newValue: unknown; ip: string | null; createdAt: string };

/** Журнал платформы (AC-SaaS-06): каждое изменение — кто, что, по какой компании. */
export default function AuditPage() {
  const [a, setAction] = useState("");
  const [page, setPage] = useState(1);
  const list = useQuery({ queryKey: ["audit-all", a, page], queryFn: () => api<{ items: Row[]; meta: { total: number } }>("GET", "/audit", undefined, { withMeta: true, query: { action: a || undefined, page, pageSize: 50 } }) });
  return (
    <>
      <PageHeader title="Журнал действий" description="Кто из сотрудников платформы что и когда сделал. Записи нельзя изменить." />
      <Select value={a} onValueChange={(v) => { setAction(v); setPage(1); }} options={AUDIT_GROUPS} aria-label="Какие действия показать" className="sm:w-72" />
      <DataTable rows={list.data?.items} loading={list.isPending} rowKey={(r) => r.id} empty={<EmptyState title="Записей нет" />}
        columns={[
          { key: "at", header: "Время", cell: (r) => dt(r.createdAt), mobile: "subtitle" },
          { key: "a", header: "Действие", cell: (r) => auditLabel(r.action), mobile: "title" },
          { key: "u", header: "Кто", cell: (r) => r.userName ?? "—" },
          { key: "c", header: "Компания", cell: (r) => (r.companyId ? <Link className="text-primary hover:underline" to={`/companies/${r.companyId}`} onClick={(e) => e.stopPropagation()}>открыть</Link> : "—") },
          { key: "v", header: "Подробности", cell: (r) => <span className="line-clamp-2 max-w-md text-xs text-muted">{describe(r.newValue)}</span> },
        ]} />
      {list.data && <Pagination page={page} pageSize={50} total={list.data.meta.total} onPageChange={setPage} />}
    </>
  );
}
